export enum PaymentStatus {
  NONE = 'NONE',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  PAID = 'PAID'
}
